module.exports = __webpack_public_path__ + "img/31dc017.png";